import { isDefined } from '@/utils/isDefined';

export const isObject = (unknown: unknown): unknown is Record<string, unknown> =>
  isDefined(unknown) && typeof unknown === 'object';
